import {Params} from '@angular/router';

// import {PropsMapping} from '@shared/interfaces';
import {Model} from './model';

// const propsMapping: PropsMapping = {
const propsMapping: Params = {
  id: 'scoreId',
  gameId: 'gameId',
  partial: 'partial',
  score1: 'score1',
  score2: 'score2',
  extrascore1: 'extrascore1',
  extrascore2: 'extrascore2',
  winner: 'winner',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
};

export class ScoreModel extends Model {
  gameId!: number;
  partial!: number;
  score1?: number;
  score2?: number;
  extrascore1?: number;
  extrascore2?: number;
  winner?: number;
  createdAt!: Date;
  updatedAt!: Date;

  static getInstance(data: Params): ScoreModel {
    const model = new ScoreModel();
    for (const prop in propsMapping) {
      if (
        data[propsMapping[prop]] === undefined ||
        data[propsMapping[prop]] === null
      ) {
        continue;
      }

      if (['createdAt', 'endDate'].includes(prop)) {
        // @TODO: ver como se hace en restauracion
        (model as Params)[prop] = data[propsMapping[prop]];
      } else {
        (model as Params)[prop] = data[propsMapping[prop]];
      }
    }

    return model;
  }
}
